import { Box, Typography } from "@mui/material";
import DeviceHubRoundedIcon from '@mui/icons-material/DeviceHubRounded';
import { DataGrid } from "@mui/x-data-grid";

const InvoiceShowLinkedWorks = ({ invoice }) => {
    const works = invoice?.works ?? [];
    const hasWorks = invoice?.invoice_type === "has_work";

    if (!hasWorks) return null;
    const columns = [
        { field: "title", headerName: "Atividade", flex: 1, sortable: false },
    ];

    const rows = works.map((work) => ({
        id: work.id,
        workId: work.id,
        title: work.title,
    }));

    return (
        <Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
                <DeviceHubRoundedIcon sx={{ color: "primary.main", mr: 1 }} />
                <Typography variant="h6" sx={{ color: "primary.main" }}> Atividades vinculadas </Typography>
            </Box>
            <Box>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    columnHeaderHeight={0}
                    hideFooter
                    disableColumnMenu
                    disableSelectionOnClick
                    disableRowSelectionOnClick
                    loading={!invoice}
                    onRowClick={(params) =>
                        window.open(`/works/${params.row.workId}`, "_blank")
                    }
                    sx={{
                        border: 'none',
                        "& .MuiDataGrid-columnHeaders": {
                            display: "none",
                            borderBottom: "none",
                        },
                        "& .MuiDataGrid-columnHeadersInner": {
                            borderBottom: "none",
                        },
                        '& .MuiDataGrid-cell': {
                            borderRight: 'none',
                            px: '2rem',
                        },
                        '& .MuiDataGrid-columnSeparator': {
                            display: 'none',
                        },
                        '& .MuiDataGrid-row': {
                            borderBottom: '1px solid theme.palette.divider',
                            cursor: 'pointer',
                        },
                    }}
                />
            </Box>
        </Box>
    );
};

export default InvoiceShowLinkedWorks;